module.exports = __webpack_public_path__ + "pictures/no-image.7a9b15a20fdb417b967c93d782b12a24.png";